export default class Params {

    constructor() {
        this.version = 'v1.0.6';
        this.assetsVersion = 'x1';
        this.scaleFactor = 1;

        this.timesPerLevel = [120, 120, 120, 120, 120, 120, 120, 120, 120, 120, 110, 100, 90, 80, 70, 60];
        this.frameBasedTimer = true;

        if (window.innerWidth > 1200 || window.innerHeight > 1200) {
            this.assetsVersion = 'x2';
            this.scaleFactor = 2
        }

        this.atlases = {
            'x1': {
                'allInOne': 1,
                'boardBackgrounds': 2
            },
            'x2': {
                'gameElements': 1,
                'flashAnims': 2,
                'flashAnims2': 3,
                'uiScreens': 4,
                'helpScreens': 5,
                'boardBackgrounds': 6
            }
        };

        this.fontsList = {
            'white': {
                'fontName': 'white',
                'sizes': [20, 24, 28, 32, 38, 44]
            },
            'whiteNumbers': {
                'fontName': 'white',
                'sizes': [20, 24, 28, 32, 38, 44, 50, 60, 70]
            },
            'blue': {
                'fontName': 'blue',
                'sizes': [14, 20, 28, 36, 48]
            },
            'green': {
                'fontName': 'green',
                'sizes': [20, 25, 30, 35, 40]
            },
            'red': {
                'fontName': 'red',
                'sizes': [10, 15, 20, 25, 30, 35, 40]
            }
        }
    }

    getFonts(color, size) {
        var availableSizes = this.fontsList[color]['sizes'];
        var minDiff = 99999999;
        var closestSize = -1;

        for (var i = 0; i < availableSizes.length; i++) {
            var diff = Math.abs(size - availableSizes[i]);
            if (diff <= minDiff) {
                minDiff = diff;
                closestSize = availableSizes[i]
            }
        }

        return this.fontsList[color]['fontName'] + '_' + closestSize
    }

    addFontsFromAtlas(preloader) {
        for (var key in this.fontsList) {
            var sizes = this.fontsList[key]['sizes'];
            var fontName = this.fontsList[key]['fontName'];

            for (var i = 0; i < sizes.length; i++) {
                var name = fontName + '_' + sizes[i];
                var xmlData = preloader.cache.getJSON('fontsData')[name + '.fnt'];
                var xml = preloader.load.parseXml(xmlData);
                preloader.cache.addXML(name, name, xml);
                preloader.game.cache.addBitmapFontFromAtlas(name, 'fontsAll', name + '.png', name, 'xml', 0, 0)
            }
        }
    }

    addFontsToAssets(assets) {
        return assets;
        var gameAssets = assets['game'];

        for (var key in this.fontsList) {
            var sizes = this.fontsList[key]['sizes'];
            var fontName = this.fontsList[key]['fontName'];

            for (var i = 0; i < sizes.length; i++) {
                var name = fontName + '_' + sizes[i];
                gameAssets.push({
                    key: name,
                    type: 'xml',
                    url: 'fontsData/' + name + '.fnt'
                })
            }
        }

        return assets
    }

    addAtlasesToAssets(assets) {
        var gameAssets = assets['game'];
        for (var key in this.atlases[this.assetsVersion]) {
            //console.log('Dodaje ', key)
            gameAssets.push({
                key: key,
                type: 'atlasJSONHash',
                atlasURL: 'images/' + PARAMS.assetsVersion + '/' + key + '.json',
                textureURL: 'images/' + PARAMS.assetsVersion + '/' + key + '.png'
            })
        }
        return assets
    }

    makeSprite(game, x, y, atlas, frame) {
        var atlases = this.atlases[this.assetsVersion];
        if (!atlases[atlas] && frame && atlas !== 'preloader') atlas = 'allInOne';
        return game.make.image(x, y, atlas, frame)
    }

    addSprite(game, x, y, atlas, frame) {
        var atlases = this.atlases[this.assetsVersion];
        if (!atlases[atlas] && frame && atlas !== 'preloader') atlas = 'allInOne';
        return game.add.sprite(x, y, atlas, frame)
    }

    addButton(game, x, y, atlas, callback, callbackTarget, normal, over, down) {
        var atlases = this.atlases[this.assetsVersion];
        if (!atlases[atlas] && atlas !== 'preloader') atlas = 'allInOne';
        return game.add.button(x, y, atlas, callback, callbackTarget, normal, over, down)
    }

}
window.PARAMS = new Params();
